export default "__VITE_ASSET__8vkKFOd4__"